// extracted by mini-css-extract-plugin
export default {"wrapper":"uploadcare_wrapper__yGd7S","output":"uploadcare_output__BmCJB","custom":"uploadcare_custom__X3vgE","uploaderCfg":"uploadcare_uploaderCfg__2UT2o"};